import { createSelector } from '@ngrx/store';

import { ValidationResponse } from '@models/swagger';
import { State } from './reducer';
import { selectValidatePartnershipCardState } from '../selectors';

export const getData = createSelector(selectValidatePartnershipCardState, (state: State) => state.data);

export const getError = createSelector(selectValidatePartnershipCardState, (state: State) => state.error);

export const getLoading = createSelector(selectValidatePartnershipCardState, (state: State) => state.loading);

export const mapData = <T>(fn: (data: ValidationResponse) => T) =>
  createSelector(selectValidatePartnershipCardState, (state: State) => fn(state.data));
